import { List, ListItem } from '@mote/ui'
import { x } from '@xstyled/styled-components'

export const WebRecorderFeaturesBanner = () => {
  return (
    <x.div
      p={4}
      bg='sky.l3'
      borderRadius='lg'
      border={1}
      borderColor='sky.l1'
      w='full'
    >
      <List text='md' color='grey.d3' spacing={2}>
        <ListItem>🚀 Mote- Fast and friendly voice notes</ListItem>
        <ListItem>🗣️ Record and transcribe your voice</ListItem>
        <ListItem>💻 Download and share online</ListItem>
      </List>
    </x.div>
  )
}
